<template>
	<div>
		<a-alert
			v-if="series[0].data.length === 0"
			:show-icon="false"
			message="No info available"
			banner
			type="info"
		/>
		<apexchart
			v-else
			type="area"
			:options="options"
			:series="series"
			:height="250"
		></apexchart>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'EvolutionComment',
	props: {
		series: {
			type: Array,
			required: true,
		},
	},
	data: function() {
		return {
			options: {
				chart: {
					type: 'area',
				},

				dataLabels: {
					enabled: false,
				},
				markers: {
					size: 2,
					style: 'hollow',
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 8,
				},
				tooltip: {
					x: {
						format: 'dd MMM yyyy',
					},
				},
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 0.9,
						opacityFrom: 0.3,
						opacityTo: 0.9,
						stops: [0, 100],
					},
				},
			},

			moment,
		}
	},
}
</script>

<style></style>
